import { getIsAllowOnlineProductPickupEnabled } from '@tcp/core/src/reduxStore/selectors/session.selectors';
import { initiateApiCall } from '../../handler';
import endpoints from '../../endpoints';
import { isCanada } from '../../../utils';

const getUnboxResult = (endPoint, query, storeId, categoryFilter, xappURLConfig) => {
  let tcpWebOnlyBopisFilter = isCanada()
    ? '-TCPWebOnlyFlagCanadaStore:1'
    : '-TCPWebOnlyFlagUSStore:1';

  if (getIsAllowOnlineProductPickupEnabled()) {
    tcpWebOnlyBopisFilter = '';
  }

  return initiateApiCall(
    {
      body: {
        start: 0,
        rows: 0,
        variants: true,
        'variants.count': 0,
        version: 'V2',
        q: query,
        'facet.multilevel': 'categoryPath',
        'f.categoryPath.displayName': 'category',
        'f.categoryPath.max.depth': 4,
        'f.categoryPath.facet.limit': 100,
        filter: `v_Quantity_${storeId.slice(-4)}:[1 TO *]${tcpWebOnlyBopisFilter}`,
        ...(categoryFilter && { 'category-filter': encodeURIComponent(categoryFilter) }),
      },
      webService: endPoint,
    },
    null,
    xappURLConfig
  ).then((res) => {
    if (
      res.body &&
      res.body.facets &&
      res.body.facets.multilevel &&
      res.body.facets.multilevel.bucket
    ) {
      return (
        Array.isArray(res.body.facets.multilevel.bucket) &&
        res.body.facets.multilevel.bucket[0].values
      );
    }
    return [];
  });
};

const fetchL1Categories = ({ storeId, xappURLConfig }) =>
  getUnboxResult(endpoints.shopThisStoreCategories, '*', storeId, '', xappURLConfig);
const fetchL2Categories = ({ storeId, categoryFilter, xappURLConfig }) =>
  getUnboxResult(endpoints.shopThisStoreCategories, '*', storeId, categoryFilter, xappURLConfig);

export default { fetchL1Categories, fetchL2Categories };
